import { DateTime } from 'luxon';

export const isLaterToday = (time: DateTime) => {
	return time.hasSame(DateTime.now(), 'day') && time > DateTime.now();
};

export const isEndOfDayToday = (time: DateTime) => {
	return (
		time.hasSame(DateTime.now().endOf('day'), 'day') && time.equals(DateTime.now().endOf('day'))
	);
};

export const isEndOfDay = (time: DateTime) => {
	return time.equals(time.endOf('day'));
};

export const isStartOfDay = (time: DateTime) => {
	return time.equals(time.startOf('day'));
};

export const isTomorrow = (time: DateTime) => {
	return time.hasSame(DateTime.now().plus({ days: 1 }), 'day');
};
